import { useEffect } from "react";

function ReturnOrder() {
  useEffect(() => {
    // Load Termly script only once
    if (!document.getElementById("termly-jssdk")) {
      const script = document.createElement("script");
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="return-wrapper">
      {/* Termly Embed */}
      <div
        name="termly-embed"
        data-id="08010eee-4551-48ee-a147-48263e5a7c57"
      ></div>
    </div>
  );
}

export default ReturnOrder;
